<!--
  This example requires some changes to your config:

  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/forms'),
    ],
  }
  ```
-->
<div class="space-y-10 divide-y divide-gray-900/10">
  <div class="grid grid-cols-1 gap-x-8 gap-y-8 pt-10 md:grid-cols-3 md:pr-4">
    <div class="px-4 sm:px-0">
      <h2 class="text-base font-semibold leading-7 text-gray-900">Regionale Einstellungen</h2>
      <p class="mt-1 text-sm leading-6 text-gray-600"></p>
    </div>

    <div class="relative bg-white shadow ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2">
      <div class="px-4 pt-2 pb-4 sm:p-8">
        <div class="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
          @if (permissionService.CheckPermission(permissionService.Administration_Settings_GetTimezone())) {
            <div class="sm:col-span-6">
              <label class="inline-flex text-sm font-medium leading-6 text-gray-900">
                <span>Server-Zeitzone</span>
              </label>
              <div class="mt-2">
                <ng-select
                  (ngModelChange)="timeZoneSet($event)"
                  [disabled]="!permissionService.CheckPermission(permissionService.Administration_Settings_SetTimezone())"
                  [items]="timeZones" [ngModel]="selectedTimeZone"
                  bindLabel="name" bindValue="id"
                  class="ng-select cheqme-style text-sm w-full" placeholder="Zeitzone wählen (Standard: Europe/Berlin)">
                  @for (zone of timeZones; track zone) {
                    <ng-option [value]="zone">
                      {{ zone }}
                    </ng-option>
                  }
                </ng-select>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>

  <div class="grid grid-cols-1 gap-x-8 gap-y-8 pt-10 md:grid-cols-3 md:pr-4">
    <div class="px-4 sm:px-0">
      <h2 class="text-base font-semibold leading-7 text-gray-900">Dienstplan Einstellungen</h2>
      <p class="mt-1 text-sm leading-6 text-gray-600"></p>
    </div>

    <div class="relative bg-white shadow ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2">
      <div class="px-4 pt-2 pb-4 sm:p-8">
        @if (shiftmaker_settings) {
          <div class="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
            @if (permissionService.CheckPermission(permissionService.Administration_Settings_GetShiftMakerSettings())) {
              <div class="sm:col-span-3">
                <label class="flex flex-col text-sm leading-6 text-gray-900">
                  <span class="font-medium">Rundungsteile pro Stunde</span>
                </label>
                <div class="mt-2">
                  <input (focusout)="shiftmaker_settings_save()"
                         [(ngModel)]="shiftmaker_settings.segmentsPerHour"
                         [disabled]="!permissionService.CheckPermission(permissionService.Administration_Settings_SetShiftMakerSettings())"
                         class="mt-2 text-center block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6"
                         max="60" min="1"
                         step="1"
                         type="number">
                </div>
                <div class="mt-2 text-sm text-gray-600">
                  <span class="font-bold">Hinweise:</span>
                  <ul class="list-disc">
                    <li>15-Minuten-Abschnitte &rarr; 4 Rundungsteile</li>
                    <li>muss Teiler von 60 sein, z. B. 4, 6, 10, 15</li>
                  </ul>
                </div>
              </div>
              <div class="sm:col-span-3">
                <label class="flex flex-col text-sm leading-6 text-gray-900">
                  <span class="font-medium">Zeitpunkt zum Aufrunden</span>
                </label>
                <div class="mt-2">
                  <input (focusout)="shiftmaker_settings_save()"
                         [(ngModel)]="shiftmaker_settings.segmentRoundingPoint"
                         [disabled]="!permissionService.CheckPermission(permissionService.Administration_Settings_SetShiftMakerSettings())"
                         class="mt-2 text-center block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6"
                         max="60" min="1"
                         step="1"
                         type="number">
                </div>
                <div class="mt-2 text-sm text-gray-600">
                  <span class="font-bold">Hinweise:</span>
                  <ul class="list-disc">
                    <li>ab 5 Minuten nach Abschnittsanfang aufrunden &rarr; 5 Minuten</li>
                    <li>max. Wert 60 / Rundungsteile</li>
                  </ul>
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>

  <!--
    The company-wide account-security policy (#282). It gates ITSELF on PlatformOwner/CompanyOwner and on the
    session having a company, and renders nothing otherwise - deliberately narrower than this screen, which a
    ShardAdmin may reach but whose two endpoints refuse them. See the component's class doc.
  -->
  <company-account-security-requirement/>

  <!--<div class="grid grid-cols-1 gap-x-8 gap-y-8 pt-10 md:grid-cols-3 md:pr-4">
    <div class="px-4 sm:px-0">
      <h2 class="text-base font-semibold leading-7 text-gray-900">Logo Einstellungen</h2>
      <p class="mt-1 text-sm leading-6 text-gray-600">Die maximal akzeptierte Dateigröße ist {{maxFileSizeMb}}MB.</p>
    </div>

    <div class="relative bg-white shadow ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2">
      <div class="px-4 pt-2 pb-4 sm:p-8">
        <div class="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
          <div class="sm:col-span-6" *ngIf="permissionService.CheckPermission(permissionService.Admin_Settings_GetTimezone())">
            <label class="inline-flex text-sm font-medium leading-6 text-gray-900">
              <span>Aktuelles Logo</span>
            </label>
            <div class="mt-2">

            </div>
            <label class="inline-flex text-sm font-medium leading-6 text-gray-900">
              <span>Neues Logo</span>
            </label>
            <div class="mt-2 flex">
              <input class="place-self-center p-0 m-0 w-full" type="file" id="file" accept="image/*" width="512" height="512" />
              <button class="place-self-center bg-cyan-600 hover:bg-cyan-800 cursor-pointer select-none rounded-lg text-white px-2 py-1" type="submit" (click)="upload($event)">Upload</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>-->
</div>
